import React from 'react';
import { useTranslation } from 'react-i18next';
import { setDocLang, useDocLang } from '../../lib/docLang';

/** Small PL/EN switch shown next to download buttons (admin-enabled per user). */
export const DocLangToggle = ({ testId = 'doc-lang-toggle', className = '' }) => {
  const { t } = useTranslation();
  const { enabled, lang } = useDocLang();
  if (!enabled) return null;
  return (
    <div
      className={`inline-flex items-center rounded-full border border-slate-200 bg-white p-0.5 text-[10px] font-semibold ${className}`}
      title={t('docLang.title')}
      data-testid={testId}
    >
      {['pl', 'en'].map((l) => (
        <button
          key={l}
          type="button"
          onClick={(e) => { e.stopPropagation(); setDocLang(l); }}
          className={`rounded-full px-1.5 py-0.5 uppercase transition-colors ${lang === l ? 'bg-slate-800 text-white' : 'text-slate-500 hover:text-slate-800'}`}
          aria-pressed={lang === l}
          data-testid={`${testId}-${l}`}
        >
          {l}
        </button>
      ))}
    </div>
  );
};

export default DocLangToggle;
